export const FirebaseConfig = {
	"projectId": "singh-taxi",
	"appId": "1:1079308835837:web:03e1096313dca958b39794",
	"databaseURL": "https://singh-taxi-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "singh-taxi.firebasestorage.app",
	"apiKey": "AIzaSyCl4B02YI7l-e7F8VF-mwSlhBX_funHVJw",
	"authDomain": "singh-taxi.firebaseapp.com",
	"messagingSenderId": "1079308835837",
	"measurementId": "G-7B9N4J5823",
	"projectNumber": "1079308835837",
	"version": "2"
};